if (!customElements.get('product-audio-preview')) {
  // Card play button. Playback happens in the fixed bottom <audio-player-bar>;
  // this element sends it the track and mirrors its state.
  class ProductAudioPreview extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.product-audio-preview__button');
      if (!this.button) return;

      this.abortController = new AbortController();
      const { signal } = this.abortController;

      this.button.addEventListener('click', this.onButtonClick.bind(this), { signal });
      document.addEventListener('audio-player:change', this.onPlayerChange.bind(this), { signal });

      // Cards re-rendered by filters or load more pick up the current player state.
      const player = document.querySelector('audio-player-bar');
      if (player && player.currentSrc === this.dataset.audioSrc) this.setState(player.state);
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    get track() {
      return {
        src: this.dataset.audioSrc,
        title: this.dataset.trackTitle,
        url: this.dataset.trackUrl,
        image: this.dataset.trackImage,
        genre: this.dataset.trackGenre,
      };
    }

    async onButtonClick(event) {
      // The button sits inside the card, which is wrapped by product links.
      event.preventDefault();
      event.stopPropagation();
      if (this.state === 'error') return;

      await customElements.whenDefined('audio-player-bar');
      const player = document.querySelector('audio-player-bar');
      if (player) player.toggle(this.track);
    }

    onPlayerChange(event) {
      const { src, state } = event.detail;
      if (src === this.dataset.audioSrc) {
        this.setState(state);
      } else if (this.state !== 'error') {
        this.setState('paused');
      }
    }

    setState(state) {
      this.state = state;
      const isPlaying = state === 'playing';
      const isLoading = state === 'loading';

      this.classList.toggle('is-playing', isPlaying);
      this.classList.toggle('is-loading', isLoading);
      this.classList.toggle('is-unavailable', state === 'error');

      this.querySelector('.product-audio-preview__icon--play').classList.toggle('hidden', isPlaying || isLoading);
      this.querySelector('.product-audio-preview__icon--pause').classList.toggle('hidden', !isPlaying);
      this.querySelector('.product-audio-preview__spinner').classList.toggle('hidden', !isLoading);

      let label = this.dataset.labelPlay;
      if (isPlaying || isLoading) label = this.dataset.labelPause;
      if (state === 'error') label = this.dataset.labelUnavailable;

      this.button.setAttribute('aria-label', `${label}: ${this.dataset.trackTitle}`);
      this.button.setAttribute('aria-pressed', isPlaying || isLoading);
      this.button.disabled = state === 'error';
    }
  }

  customElements.define('product-audio-preview', ProductAudioPreview);
}
